import styled, { css } from "styled-components";
import media from "styled-media-query";
import breakpoints from "Helpers/BreakpointHelper";

export const FocalPointImage = styled.div.attrs(
  ({ isCropped, coordinates }) => ({
    isCropped: isCropped,
    coordinates: coordinates,
  })
)`
  ${({ isCropped }) =>
    !isCropped &&
    css`
      background-position: 50% center;
    `}

  ${({ coordinates }) =>
    coordinates !== undefined &&
    coordinates.x !== undefined &&
    css`
      background-position: ${coordinates.x}% ${coordinates.y}%;     
    `}
`;
